var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '@storeblocks/loading-indicator';
import { getText } from '@storebrand-digital/fms-translations';
import { SystemIcon } from '@storeblocks/icon';
import FileUpload from '../../../components/FileUpload';
import FileList from '../../../components/FileList';
import IconButton from '../../../components/IconButton';
import Textarea from '../../../components/Textarea';
import ErrorComponent from '../../../components/ErrorComponent';
import { Wrap, ReplyBase, TextAreaWrap, ResponseWrap, ErrorWrap, } from './styled';
import { replyToThreadRequested } from '../redux/messageThreadSlice';
function ReplyBox() {
    var _this = this;
    var id = useParams().id;
    var dispatch = useDispatch();
    var _a = useState(''), message = _a[0], setMessage = _a[1];
    var _b = useState(true), filesValid = _b[0], setFilesValid = _b[1];
    var _c = useState([]), files = _c[0], setFiles = _c[1];
    var _d = useState(false), slow = _d[0], setSlow = _d[1];
    var timer = useRef(null);
    var _e = useSelector(function (state) { return state.messageThread.replyToThread; }), loading = _e.loading, success = _e.success, error = _e.error;
    var onChange = function (event) {
        setMessage(event.target.value);
    };
    var onUploadFile = function (uploaded) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setFiles(__spreadArray(__spreadArray([], files, true), uploaded, true));
            return [2 /*return*/];
        });
    }); };
    var onRemoveFile = function (updatedFiles) {
        setFiles(updatedFiles);
    };
    var onSend = function () {
        if (filesValid && (message !== '' || files.length !== 0)) {
            dispatch(replyToThreadRequested({
                threadId: id,
                body: message,
                files: files,
            }));
            timer.current = setTimeout(function () {
                setSlow(true);
            }, 3000);
        }
    };
    useEffect(function () {
        var wrapper = document.querySelector('#upload-reply');
        var observer = new IntersectionObserver(function (_a) {
            var e = _a[0];
            return e.target.classList.toggle('isSticky', !e.isIntersecting);
        }, {
            rootMargin: '0px 0px -1px 0px',
            threshold: [1],
        });
        if (wrapper) {
            observer.observe(wrapper);
        }
    }, []);
    useEffect(function () {
        if (success) {
            setFiles([]);
            setMessage('');
            setSlow(false);
        }
    }, [success]);
    useEffect(function () { return function () { return clearTimeout(timer.current); }; }, []);
    function renderContent() {
        if (loading) {
            return (React.createElement(ResponseWrap, null,
                React.createElement(LoadingIndicator, null),
                slow ? (React.createElement("p", null, getText('compose.loading.slow.description'))) : (React.createElement("p", null, getText('compose.loading.description')))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(ReplyBase, null,
                React.createElement(FileUpload, { id: "upload_reply", onUploadFile: onUploadFile }),
                React.createElement(TextAreaWrap, null,
                    React.createElement(Textarea, { id: "textarea", name: "ReplyBox-input", onChange: onChange, value: message, placeholder: getText('replybox.placeholder'), minRows: 1 }),
                    files.length > 0 && (React.createElement(FileList, { files: files, onRemoveFile: onRemoveFile, setIsValid: setFilesValid, isRedBackground: true }))),
                React.createElement(IconButton, { active: message !== '', disabled: loading, variant: "icon", onClick: onSend },
                    React.createElement(SystemIcon, { name: "arrow-right", size: 16 }))),
            error && (React.createElement(ErrorWrap, null,
                React.createElement(ErrorComponent, { isCompose: true, error: error })))));
    }
    return React.createElement(Wrap, { id: "upload_reply" }, renderContent());
}
export default ReplyBox;
